"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports["default"] = void 0;

var _react = require("react");

var _framerMotion = require("framer-motion");

var _utils = _interopRequireDefault(require("../utils"));

/* eslint-disable react-hooks/exhaustive-deps */
// Listens to user scroll movement, checking if component is visible within the viewport
var useElementVisibleTrigger = function useElementVisibleTrigger(_ref) {
  var _ref$delay = _ref.delay,
      delay = _ref$delay === void 0 ? 0 : _ref$delay,
      componentRef = _ref.componentRef;

  var _useState = (0, _react.useState)(false),
      visible = _useState[0],
      setVisible = _useState[1];

  var _useViewportScroll = (0, _framerMotion.useViewportScroll)(),
      scrollY = _useViewportScroll.scrollY;

  var timeout = (0, _react.useRef)();
  var interval = (0, _react.useRef)();
  var intervalCount = (0, _react.useRef)(0);

  var animationTimeout = function animationTimeout() {
    timeout.current = setTimeout(function () {
      setVisible(true);
    }, delay);
  };

  (0, _react.useEffect)(function () {
    if (componentRef != null && componentRef.current && _utils["default"].isInViewport(componentRef == null ? void 0 : componentRef.current)) {
      animationTimeout();
    } // Checks if component is within viewport for 3 seconds within windows that are not scrollable


    interval.current = setInterval(function () {
      if (componentRef != null && componentRef.current && _utils["default"].isInViewport(componentRef == null ? void 0 : componentRef.current)) {
        animationTimeout();
      }

      intervalCount.current += 1;

      if (intervalCount.current > 30) {
        clearTimeout(interval.current);
      }
    }, 100);
    var cancelOnChangeScroll = scrollY.onChange(function () {
      if (componentRef != null && componentRef.current && _utils["default"].isInViewport(componentRef == null ? void 0 : componentRef.current)) {
        animationTimeout();
      }
    });
    return function () {
      cancelOnChangeScroll();

      if (timeout.current) {
        clearTimeout(timeout.current);
      }

      if (interval.current) {
        clearTimeout(interval.current);
      }
    };
  }, []);
  return visible;
};

var _default = useElementVisibleTrigger;
exports["default"] = _default;